import React from "react";

const Header = () => (
  <header className="masthead d-flex animated-parent margin-top-55">
    <div className="container text-center my-auto slowest animated fadeIn">
      <h1 className="mb-1"><img className="logo" src="./img/logo.png"/></h1>
      <h3 className="mb-5 padding-top">
        <em>Unser Zweck ist es den Menschen eine Möglichkeit zu zeigen ihre Gesundheit zu erhalten oder wieder zu erlangen</em>
      </h3>
      <a className="btn btn-primary btn-xl js-scroll-trigger" href="#pillars">Mehr herausfinden</a>
    </div>
    <div className="overlay" />
  </header>
);
export default Header;



// WEBPACK FOOTER //
// ./src/main/header.js